export default __webpack_public_path__ + "static/media/Edona-Sina.32f2f0de.jpg";